/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { ClassroomUserBulkSaveItemViewModel } from "../types/ClassroomUserBulkSaveItemViewModel.ts";

export const classroomUserBulkSaveItemViewModelSchema = z.object({
  id: z.optional(z.number().int()),
  personId: z.optional(z.number().int()),
  grade: z.number().nullish(),
  gradeUpdated: z.optional(z.boolean()),
  gradeManual: z.optional(z.boolean()),
  attendance: z.optional(z.boolean()),
  notes: z.string().nullish(),
}) as unknown as ToZod<ClassroomUserBulkSaveItemViewModel>;
